import { Grid2 } from "@mui/material";
import type { BookingScheduleInterface } from "../../../../../features/Booking-Form/typings/booking.types";
import {
  resolveResourceBookingApprovalStatus,
  resolveResourceBookingDeliveryStatus,
  shouldShowResourceBookingBelowName,
  shouldShowResourceBookingQuantity
} from "../../../../../features/Schedule/utils/resource-booking-schedule.utils";
import { ScheduleResourceBookingApprovalStatus } from "./ScheduleResourceBookingApprovalStatus.partial";
import { ScheduleResourceBookingDeliveryStatus } from "./ScheduleResourceBookingDeliveryStatus.partial";
import { ScheduleResourceBookingQty } from "./ScheduleResourceBookingQty.partial";

type ScheduleResourceBookingBelowNameProps = Readonly<{
  schedule: BookingScheduleInterface;
  isEditable: boolean;
  refetchAllSchedule?: () => void;
}>;

/** Compact Order / Approval / Qty lines under the resource title. */
export function ScheduleResourceBookingBelowName({
  schedule,
  isEditable,
  refetchAllSchedule
}: ScheduleResourceBookingBelowNameProps) {
  if (!shouldShowResourceBookingBelowName(schedule)) {
    return null;
  }

  const deliveryStatus = resolveResourceBookingDeliveryStatus(schedule);
  const approvalStatus = resolveResourceBookingApprovalStatus(schedule);
  const showQty = shouldShowResourceBookingQuantity(schedule);

  return (
    <Grid2
      container
      direction="column"
      gap={0.5}
      sx={{ width: "100%", pl: 0 }}
      data-testid="schedule-resource-booking-below-name"
    >
      {deliveryStatus != null && <ScheduleResourceBookingDeliveryStatus schedule={schedule} />}
      {approvalStatus != null && <ScheduleResourceBookingApprovalStatus schedule={schedule} />}
      {showQty && (
        <ScheduleResourceBookingQty
          schedule={schedule}
          isEditable={isEditable}
          refetchAllSchedule={refetchAllSchedule}
        />
      )}
    </Grid2>
  );
}
